import { render } from "./MyAccountOrders.vue?vue&type=template&id=393f1078"
import script from "./MyAccountOrders.vue.ts?vue&type=script&lang=ts"
export * from "./MyAccountOrders.vue.ts?vue&type=script&lang=ts"
script.render = render

export default script